import { render } from "./Show.vue?vue&type=template&id=fe7f50e4&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=fe7f50e4&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7f50e4"],['__file',"resources/js/pages/message/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe7f50e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe7f50e4', __exports__)) {
    console.log('reload')
    api.reload('fe7f50e4', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=fe7f50e4&scoped=true", () => {
    console.log('re-render')
    api.rerender('fe7f50e4', render)
  })

}


export default __exports__